import { deepPatch } from 'Shared/common/deepPatch';
import { IStoreWrap } from 'Shared/StoreProvider';
import { produce, reconcile} from 'solid-js/store';


/* Deeply merges fields into a document */
export async function dbPatchFields<D>(sw:IStoreWrap<D>,fields:any)
{
	sw.setStore?.(...sw.location,produce(data => deepPatch(data,fields)));

	if (sw.noDb) return;

	return await sw.server.patch.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:fields});
}

/* This is pretty much a convenience version of dbMergeFields(), merging just a single field */
export async function dbPatchField<D>(sw:IStoreWrap<D>,field:string,value:any)
{
	sw.setStore?.(...sw.location,field,reconcile(value));

	if (sw.noDb) return;

	return await sw.server.patch.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:{[field]:value}});
}

export async function dbReplaceField<D>(sw:IStoreWrap<D>,field:string,value:any)
{
	sw.setStore?.(...sw.location,field,value);

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:[...sw.location,field],fields:value});
}

/* Replaces the subdoc at sw.location with value. */
export async function dbReplaceSubdoc<D>(sw:IStoreWrap<D>,value:any)
{
	sw.setStore?.(...sw.location,reconcile(value));

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:value});
}


